import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  GlueCatalogARN,
  GlueCatalogID,
  GlueTableUpdatedAt,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSGlueDataCatalogMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        name={metadata}
        arn="None"
        createdAt={metadata}
        vpc="None"
        availabilityZone="None"
        state="None"
        tags="None"
      />
      {GlueTableUpdatedAt(metadata)}
      {GlueCatalogID(metadata)}
      {GlueCatalogARN(metadata)}
    </Grid>
  );
};
